import { Component, Input } from '@angular/core';
import { PERFIL_COPY } from '../../../data/perfil-microempresario.content';

@Component({
  selector: 'app-perfil-progress-general',
  templateUrl: './perfil-progress-general.component.html',
  styleUrls: ['./perfil-progress-general.component.scss'],
  standalone: false,
})
export class PerfilProgressGeneralComponent {
  @Input() progreso = 0;
  @Input() seccionesCompletas = 0;
  @Input() totalSecciones = 3;
  @Input() titulo = PERFIL_COPY.hub.title;

  readonly copy = PERFIL_COPY;

  get progresoClamped(): number {
    return Math.max(0, Math.min(100, this.progreso ?? 0));
  }
}
